import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

export const COMPANY_PARTY_CONTENT_PATH = 'licenses.steps.businessInformation.forms.companyParty';

export const companyPartySchema = BasicBusinessInformationSchema.extend({
  eventDate: z
    .string()
    .min(1, { message: `${COMPANY_PARTY_CONTENT_PATH}.eventDate.validation.required` })
    .regex(/^\d{4}-\d{2}-\d{2}$/, {
      message: `${COMPANY_PARTY_CONTENT_PATH}.eventDate.validation.validFormat`,
    }),
  participantCount: z
    .number({
      required_error: `${COMPANY_PARTY_CONTENT_PATH}.participantCount.validation.required`,
      invalid_type_error: `${COMPANY_PARTY_CONTENT_PATH}.participantCount.validation.required`,
    })
    .int({ message: `${COMPANY_PARTY_CONTENT_PATH}.participantCount.validation.required` })
    .min(1, { message: `${COMPANY_PARTY_CONTENT_PATH}.participantCount.validation.minimum` }),
});

export type CompanyPartyForm = z.infer<typeof companyPartySchema>;

export const createCompanyPartyDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.CompanyParty,
  eventDate: '',
});

export const toPayloadCompanyParty = (form: CompanyPartyForm, wareNumber: number): GeneralPayload => {
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs(form.eventDate).format('YYYY-MM-DD'),
    quantity: form.participantCount ?? 0,
  };
};
